import {DataTable, exportCSV} from 'simple-datatables';
import {LanguageUtility} from './language-utility';
import {DataTableOptions} from 'simple-datatables/dist/dts/types';

/**
 * Helps in dealing with simple datatables.
 */
export class SimpleDatatablesUtility {
  /**
   * Creates a new data table instance.
   *
   * @param {HTMLTableElement} table Table element to use as a base
   * @param {object} data Table data
   * @param {Partial<DataTableOptions>} options Data table options
   */
  public static createDatatableInstance(table: HTMLTableElement, data: object = {}, options: Partial<DataTableOptions> = {}): DataTable {
    options.data = data;
    options.labels = {
      placeholder: LanguageUtility.translate('simpleDatatables.labels.placeholder'),
      searchTitle: LanguageUtility.translate('simpleDatatables.labels.searchTitle'),
      pageTitle: LanguageUtility.translate('simpleDatatables.labels.pageTitle'),
      perPage: LanguageUtility.translate('simpleDatatables.labels.perPage'),
      noRows: LanguageUtility.translate('simpleDatatables.labels.noRows'),
      info: LanguageUtility.translate('simpleDatatables.labels.info'),
      noResults: LanguageUtility.translate('simpleDatatables.labels.noResults')
    };
    options.fixedColumns = true;

    options.tableRender = (data: any, tableNode: any, type: any) => {
      if (!tableNode.attributes || !tableNode.attributes.id) {
        return;
      }
      const table = document.querySelector('#' + tableNode.attributes.id);
      if (!table) {
        return;
      }
      const wrapper = table.closest('.datatable-wrapper');
      if (!wrapper) {
        return;
      }
      const dropdownContainer = wrapper.querySelector('.datatable-dropdown');
      if (dropdownContainer) {
        const perPageSelect = wrapper.querySelector('.datatable-selector');
        const perPageLabel = wrapper.querySelector('.datatable-top label');
        if (perPageSelect && perPageLabel) {
          perPageSelect.classList.add('form-control', 'form-control-sm');
          dropdownContainer.append(perPageSelect);
        }
      }
      const searchField = wrapper.querySelector('.datatable-input');
      if (searchField) {
        searchField.classList.add('form-control', 'form-control-sm');
      }
    };
    return new DataTable(table, options);
  }

  /**
   * Pushes a CSV file download of the current table.
   *
   * @param {DataTable} dataTable Data table instance
   */
  public static downloadCsv = function (dataTable: DataTable) {
    const options = {
      download: false,
      lineDelimiter: '\n',
      columnDelimiter: ';'
    };

    const csv = exportCSV(dataTable, options);
    if (!csv) {
      return false;
    }
    const string = `${options.lineDelimiter}${csv}${options.lineDelimiter}`;

    const link = document.createElement('a');
    link.href = encodeURI(`data:text/csv;charset=utf-8,${string}`);
    link.download = 'export.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
}
